import {ApiClient} from '@hconnect/apiclient'
import {AutocompleteOption} from '@hconnect/common/maintain-filters'
import {useQuery} from '@tanstack/react-query'

type PlantAndCountry = {
  plantId: string
  plantName: string
  countryCode: string
  countryName: string
}

type StoppagePlantsResponse = PlantAndCountry[]

export const QueryKey = 'stoppage-list-plants'

export const useGetStoppagePlants = () => {
  return useQuery({
    queryKey: [QueryKey],
    queryFn: async () => {
      return (
        await ApiClient.axiosInstance.get<StoppagePlantsResponse>(
          '/rootcausefailureanalysis/stoppages/restrictive-cement-plants'
        )
      ).data
    },
    // these default values will get moved to the api provider soon
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
    select: (data) => generateOptions(data)
  })
}

const generateOptions = (data: PlantAndCountry[]) => {
  const autocompleteOptions: AutocompleteOption[] = []

  data.forEach((option) => {
    const id = option.plantId
    const value = option.plantName

    autocompleteOptions.push({
      id: id,
      label: value
    })
  })

  return autocompleteOptions
}
